export default "__VITE_ASSET__DOcxMCqW__"